module.exports = __webpack_public_path__ + "hyperion-v2-static/img/noimage.3d74be43.png";